export default "__VITE_ASSET__HLwo0qs0__"